<template>
  <div>
    <div class="row">
      <BillingMonth />
      <BilletPaymentDash />
    </div>
    <div class="row">
      <BillingServiceDash />
      <BillingDayDash />
    </div>
  </div>
</template>
<script>
import BillingMonth from "./financial/graph/BillingMonth";
import BilletPaymentDash from "./financial/graph/BilletPaymentDash";
import BillingServiceDash from "./financial/graph/BillingServiceDash";
import BillingDayDash from "./financial/graph/BillingDayDash";

export default {
  name: "GraphBilling",
  components: {
    BillingMonth,
    BilletPaymentDash,
    BillingServiceDash,
    BillingDayDash,
  },
};
</script>
